import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Qué es exactamente El Código del Cierre™?',
    a: 'Es una guía digital en PDF de 21 días, diseñada con principios de psicología simbólica para ayudarte a procesar, soltar y cerrar un ciclo emocional de forma guiada y privada.'
  }, {
    q: '¿Cómo se entrega el producto?',
    a: 'Inmediatamente después de tu compra segura, recibirás un correo electrónico con los enlaces para descargar la guía principal, el plan de acción y todos los bonos directamente a tu celular, tablet o computadora.'
  }, {
    q: '¿Cuánto tiempo me tomará al día?',
    a: 'El sistema está diseñado para mujeres ocupadas. Solo necesitas entre 10 y 15 minutos diarios para leer la reflexión del día y realizar el acto simbólico de cierre propuesto.'
  }, {
    q: '¿Necesito experiencia previa en meditación o desarrollo personal?',
    a: 'No. El lenguaje es sencillo, directo y muy empático. No necesitas conocimientos previos, solo la disposición de seguir los pasos.'
  }, {
    q: '¿Funciona si la ruptura fue hace mucho tiempo?',
    a: 'Sí. El tiempo no cura por sí solo si no hay un cierre emocional. Si sigues sintiendo apego, nostalgia o sigues esperando una señal, este sistema te ayudará a desengancharte sin importar cuánto tiempo haya pasado.'
  }, {
    q: '¿Esto reemplaza ir a terapia?',
    a: 'NO. Este producto tiene fines educativos y de acompañamiento personal. Es una excelente herramienta complementaria, pero no sustituye el asesoramiento psicológico profesional si estás atravesando una depresión clínica o trauma severo.'
  }, {
    q: '¿Por qué cuesta solo $6.99 USD?',
    a: 'Es una oferta especial de lanzamiento. Queremos que esta herramienta sea accesible para la mayor cantidad de mujeres hispanas posible, sin que el precio sea un obstáculo para recuperar su paz.'
  }, {
    q: '¿Cómo funciona la garantía de 7 días?',
    a: 'Si compras el sistema, lo revisas y sientes que no es para ti, solo tienes que enviarnos un correo dentro de los primeros 7 días y te devolveremos el 100% de tu dinero, sin hacer preguntas incómodas.'
  }, {
    q: '¿Puedo hacerlo a mi propio ritmo?',
    a: 'Aunque sugerimos hacerlo en 21 días consecutivos para mantener el momentum emocional, el material es tuyo para siempre. Puedes pausar y retomar cuando lo necesites.'
  }, {
    q: '¿Qué pasa inmediatamente después de comprar?',
    a: 'Serás redirigida a una página de confirmación y en segundos llegará un email a tu bandeja de entrada con tu acceso exclusivo a todo el material.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-blush" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <div className="text-center mb-14" data-id="element-165">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full border border-soft/40 shadow-sm mb-4" data-id="element-166">
            <HelpCircle size={14} className="text-accent" data-id="element-167" />
            <span className="font-sans text-xs font-bold text-primary tracking-wide uppercase" data-id="element-168">
              Resolvemos tus dudas
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary" data-id="element-169">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-170">
          {faqs.map((faq, i) => <div key={i} className={`border-2 rounded-xl overflow-hidden bg-white shadow-md transition-all ${openIndex === i ? 'border-accent/50' : 'border-soft/40'}`} data-id="element-171">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none gap-4" data-id="element-172">
                <span className="font-sans font-bold text-primary text-sm md:text-base pr-2" data-id="element-173">
                  {faq.q}
                </span>
                <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${openIndex === i ? 'bg-accent text-white rotate-180' : 'bg-blush text-accent'}`} data-id="element-174">
                  <ChevronDown size={18} data-id="element-175" />
                </div>
              </button>
              <AnimatePresence data-id="element-176">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-177">
                    <div className="px-6 pb-5 pt-1 text-ink/75 font-sans text-sm leading-relaxed border-t border-soft/30" data-id="element-178">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}